import React from 'react';

const Header = ({ category, title }) => (
  <div className=" mb-4">
    <p className="text-lg text-gray-400">{category}</p>
    <p className="text-1xl font-extrabold tracking-tight text-slate-900 uppercase break-words">
      {title}
    </p>
  </div>
);

export default Header;
